<template>
    <RewardSelectionIframe iframe-title="GlücksradPrämie" :form-ids="FORM_IDS" />
</template>

<script setup>
import RewardSelectionIframe from '../components/RewardSelectionIframe.vue';

const FORM_IDS = {
    production: 'a8004f53-794b-40c1-8fe1-c427af145fd3',
    staging: '8b01898f-adff-48f2-bd3b-d228dab7ce1f',
    dev: '8b01898f-adff-48f2-bd3b-d228dab7ce1f'
};
</script>
